<template>
  <div style="height: 100%;">
    <v-card class="left-panel-card">
      <v-row no-gutters class="pa-4 desktop-left-panel">
        <span>{{ $t(`label.welcomeBack`) }}</span>
        <v-col cols="12">
          <div class="grey-card member-vip-card">
            <v-row no-gutters class="pa-3 card-row">
              <img src="/static/svg/account-grey2.svg" class="left-panel-icon mr-2" />
              <span class="panel-purple-text">{{ isLoggedIn ? (memberInfo ? memberInfo.memberCode : '') : '' }}</span>
            </v-row>
          </div>
        </v-col>

        <v-col cols="12">
          <div class="grey-card member-vip-card">
            <v-row no-gutters class="pa-3 card-row">
              <img v-if="isLoggedIn" :src="`${memberVipTierProgress.image}`" class="left-panel-icon mr-2" />
              <img v-else :src="mediaUrl + '/vipTier/newMember.png'" class="left-panel-icon mr-2" />
              <v-col>
                <span v-if="isLoggedIn" class="mr-1 text-uppercase">{{ $t(`label.vipText`) }} {{ currentLevel }}</span>
                <span v-else class="mr-1 text-uppercase">{{ $t(`label.vipText`) }} {{ $t(`label.newMember`) }}</span>
              </v-col>
              <v-col cols="12" class="mt-2">
                <v-progress-linear rounded :indeterminate="isProgressLoading" color="#47206F" background-color="grey" :value="isLoggedIn ? vipTierProgressPercent : 0"></v-progress-linear>
              </v-col>
              <v-col cols="12" class="mt-1">
                <span v-if="isLoggedIn" class="progress-text">{{ progressLabel }}</span>
                <span v-else class="progress-text">{{ '0 / 0' }}</span>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters class="desktop-left-panel">
        <v-col cols="12">
          <v-list dense class="menu-list">
            <v-list-group :value="isWalletOpen">
              <template v-slot:activator>
                <v-list-item-icon>
                  <img :src="`/static/svg/leftPanel/account-wallet.svg`" alt width="18" height="18" />
                </v-list-item-icon>
                <v-list-item-title style="font-weight: bold;">{{ $t(`label.accountWallet`) }}</v-list-item-title>
              </template>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.DEPOSIT, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.deposit`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.WITHDRAWAL, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.withdrawal`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.CLAIM_VOUCHER, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.redeemVoucher`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-group :value="isRewardOpen">
              <template v-slot:activator>
                <v-list-item-icon>
                  <img :src="`/static/svg/leftPanel/rewards.svg`" alt width="18" height="18" />
                </v-list-item-icon>
                <v-list-item-title style="font-weight: bold;">{{ $t(`label.rewards`) }}</v-list-item-title>
              </template>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.INSTANT_REBATE, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.instantRebate`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.PROFILE_REFERRAL_TIER, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.referral`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.REWARD_STORE_ITEM, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.rewardStore`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.WOF, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.wofv3`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-group :value="isHistoryOpen">
              <template v-slot:activator>
                <v-list-item-icon>
                  <img :src="`/static/svg/leftPanel/history.svg`" alt width="18" height="18" />
                </v-list-item-icon>
                <v-list-item-title style="font-weight: bold;">{{ $t(`label.history`) }}</v-list-item-title>
              </template>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.TURNOVER, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.turnoverHistory`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.PLAYER_HISTORY, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.playerHistory`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.TRANSACTION_HISTORY, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.walletHistory`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-group :value="isProfileOpen">
              <template v-slot:activator>
                <v-list-item-icon>
                  <img :src="`/static/svg/leftPanel/profile.svg`" alt width="18" height="18" />
                </v-list-item-icon>
                <v-list-item-title style="font-weight: bold;">{{ $t(`label.profile`) }}</v-list-item-title>
              </template>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.PERSONAL, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.profileSettings`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.INBOX, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.inboxMessages`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="menu-button" active-class="menu-button-active" :to="{ name: routeName.CHANGE_PASSWORD, params: { lang: this.$route.params.lang } }">
                <v-list-item-content>
                  <v-list-item-title>{{ $t(`label.password`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-col>
      </v-row>
      <v-row no-gutters class="pa-4 desktop-left-panel">
        <v-col cols="12">
          <div class="grey-card">
            <v-row no-gutters class="card-row">
              <v-col class="g-text" cols="12">
                <span>{{ $t(`label.referralProgram`) }}</span>
              </v-col>
              <v-col cols="12" class="mt-1">
                <p style="font-size: 12px">{{ $t(`label.leftPanelReferralProgram`) }}</p>
              </v-col>
              <v-col cols="12">
                <div class="share-div">
                  <div class="referralCode-div" style="">
                    <span class="grey-text-field ref-text panel-purple-text">{{ referralOverview.my_referral_code }}</span>
                  </div>
                  <div class="share-btn-div">
                    <v-btn icon class="share-btn" @click="share">
                      <img src="/static/svg/share-outline.svg" />
                    </v-btn>
                  </div>
                </div>
                <div class="share-btn-div">
                  <v-btn icon class="invite-now-btn" @click="share">
                    {{ $t(`label.inviteNow`) }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { DevicePlatform } from '@/constants/enums'
import { ROUTE_NAME } from '@/constants/route.constants'
import { errorCodeHelper, locale, uiHelper } from '@/util'
import AccountBank from '@/assets/svg/profile/bank.svg'
import AccountDeposit from '@/assets/svg/profile/deposit.svg'
import AccountHistory from '@/assets/svg/profile/history.svg'
import AccountInbox from '@/assets/svg/profile/inbox.svg'
import AccountPassword from '@/assets/svg/profile/password.svg'
import AccountProfile from '@/assets/svg/profile/profile.svg'
import AccountReward from '@/assets/svg/profile/reward.svg'
import AccountVip from '@/assets/svg/profile/vip.svg'
import AccountWithdrawal from '@/assets/svg/profile/withdrawal.svg'
import { AFFILIATE_ONE_TIME_BONUS_DETAIL } from '@/store/affiliate.bonus.module'
import { REFERRAL_POST_COMMISSION, REFERRAL_RESET_COMMISSION } from '@/store/referral.module'
import stringFormat from 'string-format'
import { MEMBER_VIP_TIER_PROGRESS } from '@/store/member.module'

export default {
  name: 'appBankAndProfileSidePanel',
  components: {
    AccountBank,
    AccountDeposit,
    AccountHistory,
    AccountInbox,
    AccountPassword,
    AccountProfile,
    AccountReward,
    AccountVip,
    AccountWithdrawal
  },
  data: () => ({
    progressLabel: '',
    currentUpgradeDeposit: 0,
    requiredUpgradeDeposit: 0,
    tierColorThemeName: 'newmember',
    viptierCurLevel: -1,
    currentLevel: 'member',
    vipTireDepositProgress: 0,
    vipTierProgressPercent: 0,
    stringFormat: stringFormat,
    currentCurrency: uiHelper.getCurrency(),
    share_url: '',
    redeemCommissionAmt: 0,
    progressValue: 0,
    isProgressLoading: true,
    vipProgressLevel: 0,
    devicePlatform: DevicePlatform,
    uihelper: uiHelper,
    openNav: false,
    routeName: ROUTE_NAME,
    bankLink: [
      {
        text_key: 'deposit',
        routeName: ROUTE_NAME.DEPOSIT
      },
      {
        text_key: 'withdrawal',
        routeName: ROUTE_NAME.WITHDRAWAL
      },
      {
        text_key: 'transfer',
        routeName: ROUTE_NAME.TRANSFER
      },
      {
        text_key: 'history',
        routeName: ROUTE_NAME.TRANSACTION_HISTORY
      },
      {
        text_key: 'turnover',
        routeName: ROUTE_NAME.TURNOVER
      },
      {
        text_key: 'player-history',
        routeName: ROUTE_NAME.PLAYER_HISTORY
      },
      {
        text_key: 'bankAccount',
        routeName: ROUTE_NAME.BANK_ACCOUNT
      }
    ],
    profileLink: [
      {
        text_key: 'account',
        routeName: ROUTE_NAME.PROFILE
      },
      {
        text_key: 'personal',
        routeName: ROUTE_NAME.PERSONAL
      },
      {
        text_key: 'announcement',
        routeName: ROUTE_NAME.ANNOUNCEMENT
      },
      {
        text_key: 'referral',
        routeName: ROUTE_NAME.AFFILIATE_REFERRAL
      }
    ],
    affiliateLink: [
      {
        text_key: 'qrCode',
        routeName: ROUTE_NAME.AFFILIATE_LINK
      },
      {
        text_key: 'withdrawal',
        routeName: ROUTE_NAME.AFFILIATE_WITHDRAWAL
      },
      {
        text_key: 'history',
        routeName: ROUTE_NAME.AFFILIATE_TRANSACTION
      },
      {
        text_key: 'bankAccount',
        routeName: ROUTE_NAME.AFFILIATE_BANK_ACCOUNT
      }
    ]
  }),
  created() {
    if (this.vipProgress && this.vipProgress.required_deposit_amount >= 0 && this.vipProgress.current_deposit_progress >= 0) {
      this.progressValue = (this.vipProgress.current_deposit_progress / this.vipProgress.required_deposit_amount) * 100
      this.isProgressLoading = false
      this.vipProgressLevel = this.vipProgress.current_level_name.indexOf('Level') != -1 ? this.vipProgress.current_level_name.split(' ')[1] : ''
    }
    this.getVipTierProgress()
    this.setVipTierLevel()

    if (!_.isEmpty(this.referralOverview)) {
      this.share_url = uiHelper.getHostname() + '?refer_code=' + this.referralOverview.my_referral_code
      this.redeemCommissionAmt = this.$store.state.referral.overview.commission_balance.toFixed(2)
    }
  },
  computed: {
    vipTierDowngrade() {
      return this.$store.state.member.vipTierProgress.downgrade
    },
    vipTierUpgrade() {
      return this.$store.state.member.vipTierProgress.upgrade
    },
    memberVipTierProgress() {
      return this.$store.state.member.vipTierProgress.pairing
    },
    // navPermanent() {
    //   if($vuetify.breakpoint.mdAndDown)
    //     return false
    // }
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    affiliateBonus() {
      return this.$store.state.affiliateBonus.affiliateBonusDetail
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    vipProgress() {
      return this.$store.state.member.vipProgress
    },
    referralOverview() {
      return this.$store.state.referral.overview
    },
    redeemCommissionDetailResponseComplete() {
      return this.$store.state.referral.redeemCommissionResponse.complete
    },
    webShareApiSupported() {
      return navigator.share
    },
    watchVipCurLevel() {
      return this.viptierCurLevel
    },
    isWalletOpen() {
      return [ROUTE_NAME.DEPOSIT, ROUTE_NAME.WITHDRAWAL, ROUTE_NAME.CLAIM_VOUCHER].includes(this.$route.name);
    },
    isRewardOpen() {
      return [ROUTE_NAME.INSTANT_REBATE, ROUTE_NAME.PROFILE_REFERRAL_TIER, ROUTE_NAME.REWARD_STORE_ITEM, ROUTE_NAME.WOF].includes(this.$route.name);
    },
    isHistoryOpen() {
      return [ROUTE_NAME.TURNOVER, ROUTE_NAME.PLAYER_HISTORY, ROUTE_NAME.TRANSACTION_HISTORY].includes(this.$route.name);
    },
    isProfileOpen() {
      return [ROUTE_NAME.PERSONAL, ROUTE_NAME.INBOX, ROUTE_NAME.CHANGE_PASSWORD].includes(this.$route.name);
    }
  },
  watch: {
    watchVipCurLevel() {
      this.setTierIcon()
      this.setVipTierDetails()
    },
    memberVipTierProgress() {
      this.setVipTierLevel()
    },
    vipTierUpgrade() {},
    referralOverview() {
      this.share_url = uiHelper.getHostname() + '?refer_code=' + this.referralOverview.my_referral_code
      this.redeemCommissionAmt = this.$store.state.referral.overview.commission_balance.toFixed(2)
    },
    redeemCommissionDetailResponseComplete() {
      let response = this.$store.state.referral.redeemCommissionResponse
      if (response.complete) {
        this.redeemCommissionResponseCompleteDialog(response)
        this.$store.dispatch(`${REFERRAL_RESET_COMMISSION}`)
      }
    },
    isLoggedIn() {
      this.getAffiliateBonusDetail()
      this.getVipTierProgress()
    },
    vipProgress() {
      this.isProgressLoading = false
      let progress = this.$store.state.member.vipProgress
      if (progress && progress.required_deposit_amount && progress.current_deposit_progress) {
        this.progressValue = (progress.current_deposit_progress / progress.required_deposit_amount) * 100
        this.vipProgressLevel = progress.current_level_name.indexOf('Level') != -1 ? progress.current_level_name.split(' ')[1] : ''
      }
    }
  },
  methods: {
    setTierIcon() {
      switch (this.viptierCurLevel) {
        case 0:
          this.tierColorThemeName = 'newmember'
          break
        case 1:
          this.tierColorThemeName = 'bronze'
          break
        case 2:
          this.tierColorThemeName = 'silver'
          break
        case 3:
          this.tierColorThemeName = 'gold'
          break
        case 4:
          this.tierColorThemeName = 'emerald'
          break
        case 5:
          this.tierColorThemeName = 'sapphire'
          break
        case 6:
          this.tierColorThemeName = 'platinum'
          break
        case 7:
          this.tierColorThemeName = 'diamond'
          break
      }
    },
    setVipTierLevel() {
      if (this.memberVipTierProgress && this.memberVipTierProgress.level_sequence != undefined) {
        this.viptierCurLevel = this.memberVipTierProgress.level_sequence
        this.currentLevel = this.memberVipTierProgress.name
      }
    },
    setVipTierDetails() {
      if (this.viptierCurLevel >= 0 && this.viptierCurLevel < 6) {
        if (this.vipTierUpgrade) {
          if (this.vipTierUpgrade.required_upgrade_deposit && this.vipTierUpgrade.required_upgrade_deposit >= 0) {
            this.requiredUpgradeDeposit = Number(this.vipTierUpgrade.required_upgrade_deposit)
          }

          if (this.vipTierUpgrade.current_upgrade_deposit && this.vipTierUpgrade.current_upgrade_deposit >= 0) {
            this.currentUpgradeDeposit = Number(this.vipTierUpgrade.current_upgrade_deposit)
          }
          this.progressLabel = this.currentUpgradeDeposit.toString() + '/' + this.requiredUpgradeDeposit.toString()
        } else {
          if (this.vipTierUpgrade == null) {
            //pending upgrade tier
            this.progressLabel = locale.getMessage(`label.vipTierPendingUpgrade`)
          }
        }
      } else {
        ///highest tier level in automation = 6 , level 7 is manual upgrade rquired
        if (this.vipTierDowngrade) {
          if (this.vipTierDowngrade.required_downgrade_deposit && this.vipTierDowngrade.required_downgrade_deposit >= 0) {
            this.requiredUpgradeDeposit = Number(this.vipTierDowngrade.required_downgrade_deposit)
          }

          if (this.vipTierDowngrade.current_downgrade_deposit && this.vipTierDowngrade.current_downgrade_deposit >= 0) {
            this.currentUpgradeDeposit = Number(this.vipTierDowngrade.current_downgrade_deposit)
          }
          this.progressLabel = this.currentUpgradeDeposit.toString() + '/' + this.requiredUpgradeDeposit.toString()
        } else {
          //check for whether retention fulfilled
          if (this.vipTierDowngrade == null && this.vipTierUpgrade == null) {
            this.progressLabel = locale.getMessage(`label.vipTierRetentionFulFilled`)
          }
        }
      }

      if (this.requiredUpgradeDeposit > 0) {
        this.vipTierProgressPercent = Math.ceil((this.currentUpgradeDeposit / this.requiredUpgradeDeposit) * 100)
      } else {
        //assume Denominator = 0 mean no need to upgrade / fulfilled
        //either retention fulfilled or pending upgrade
        this.vipTierProgressPercent = 100
      }

      //regarding upgrade/downgrade is null or not as long we 100% then display fulfillment message
      if (this.vipTierProgressPercent === 100) {
        if (this.viptierCurLevel < 6) {
          this.progressLabel = locale.getMessage(`label.vipTierPendingUpgrade`)
        } else {
          this.progressLabel = locale.getMessage(`label.vipTierRetentionFulFilled`)
        }
      }
    },
    getVipTierProgress() {
      if (this.isLoggedIn) {
        this.$store.dispatch(MEMBER_VIP_TIER_PROGRESS)
      }
    },
    redeemCommissionResponseCompleteDialog(response) {
      this.closePageDialog()
      if (response.code != 0 && !response.success) {
        this.$parent.openAlert(false, errorCodeHelper.getErrorCodeDesc(response.code))
      } else {
        this.$parent.openAlert(true, locale.getMessage(`message.commissionRedeemSuccess`))
      }
    },
    getAffiliateBonusDetail() {
      this.$store.dispatch(`${AFFILIATE_ONE_TIME_BONUS_DETAIL}`)
    },
    goToRewards() {
      let routeName = this.currentCurrency === 'BDT' ? ROUTE_NAME.REWARD_STORE_ITEM : ROUTE_NAME.REWARDS
      this.$router.push({ name: routeName, params: { lang: this.$route.params.lang } })
      // this.$router.push({ name: ROUTE_NAME.REWARD_STORE_ITEM, params: { lang: this.$route.params.lang } })
    },
    redeemCommissionConfirmationDialog() {
      let self = this

      if (this.redeemCommissionAmt) {
        let dialog = this.initializePageDialogProperty()
        dialog.title = locale.getMessage(`label.redeemConfirmation`)
        dialog.message.push(this.stringFormat(locale.getMessage(`message.ConfirmCommission`), self.$options.filters.currency(this.redeemCommissionAmt, this.currentCurrency)))
        dialog.button.push({
          title: locale.getMessage(`label.confirm`),
          action: () => this.redeemCommission()
        })
        this.openPageDialog(dialog)
      }
    },
    redeemCommission() {
      let obj = { amount: this.redeemCommissionAmt }
      this.$store.dispatch(`${REFERRAL_POST_COMMISSION}`, {
        obj
      })
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closePageDialog() {
      this.$eventHub.$emit('close-page-dialog', true)
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    share() {
      const sharing = {
        title: 'Refer a friend now and earn commission',
        text: 'Your referral code is ' + this.referralOverview.my_referral_code + '.Refer a friend now and earn commission now! ',
        url: this.share_url
      }
      if (this.webShareApiSupported) {
        navigator.share(sharing)
      } else {
        let $f = this
        this.$copyText(this.share_url).then(function(e) {
          $f.alertMessage = 'Referral Link Copied!'
          $f.alertSuccess = true
          $f.alertShow = true
        })
      }
    }
  }
}
</script>

<style lang="scss">
.g-text {
  font-size: 15px;
}
.ref-text {
  font-size: 14px;
}

.left-panel-card {
  height:100%;
  border-radius: 12px !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

.desktop-left-panel {
  border-radius: 12px;
  //height: 660px;
  overflow-y: auto;
  margin-bottom: 8px !important;
  background-color: white;

  .menu-list {

    .menu-button {
      width: calc(100% - 32px);
      justify-self: center;
      padding: 0 12px;
    }

    .menu-button-active {
      width: calc(100% - 32px);
      justify-self: center;
      padding: 0 12px;
      border-radius: 16px;
      background-color: #F3F5F6;
    }

    .v-list-item {

      .v-list-item__icon {
        height: 32px;
        align-items: center;
        margin: 0 !important;
      }

      .v-list-item__title {
        font-size: 14px;
      }
    }
  }

  .grey-card {
    background-color: #ffffff !important;
    border: unset !important;
    margin-top: 8px;

    .card-row {
      align-items: center;
      font-size: 0.81rem;
    }
    .v-progress-linear__determinate {
      background-color: var(--v-newMobilePrimary-base) !important;
    }
    .v-progress-linear__background {
      background-color: #d9d9d9 !important;
    }

    .nav-btn {
      font-size: 0.7rem;
      width: 100%;
      border-radius: 20px;
      background-color: var(--v-newMobilePrimary-base);

      & span {
        width: 100%;
        text-wrap: wrap;
      }
    }
  }

  .member-vip-card {
    background-color: #f3f5f6 !important;
    border-radius: 10px;
  }

  .panel-purple-text {
    color: #47206F !important;
  }

  .share-div {
    display: flex;
    align-items: center;
    gap: 5px;

    .referralCode-div {
      width: 80%;
      height: 32px;
    }

    .share-btn-div {
      width: 32px;
      height: 32px;
    }
  }
  .grey-text-field {
    background-color: #F3F5F6;
    border-radius: 10px;
    width: 100%;
    height: 32px;
    padding: 0 6px;
    align-content: center;
    display: inline-block;
  }

  .left-panel-icon {
    width: 30px;
    height: 30px;
  }

  .share-btn {
    background-color: #47206F;
    border-radius: 8px;
    width: 100%;
    height: 30px;

    .share-icon {
      width: 20px;
      height: 20px;
    }
  }

  .invite-now-btn {
    width: 100%;
    height: 30px;
    font-size: 13px;
    border-radius: 32px;
    text-transform: capitalize;
    margin-top: 4px;
    color: white !important;
    background-color: #FF9E2D;
  }
}

.desktop-navigation-drawer {
  font-size: 12px;
  border-radius: 20px;
  height: 660px;
  .nav-title {
    color: #acacac;
  }
  .profile-nav-button {
    .mobile-icon {
      fill: #3a3a3a;
      path {
        fill: #3a3a3a;
      }
    }
    .mobile-icon-deposit {
      fill: #3a3a3a !important;
    }
    // &:hover {
    //   color: #0C2AAB !important;
    //   .mobile-icon {
    //     fill: #0C2AAB !important;
    //     path {
    //       fill: #0C2AAB !important;
    //     }
    //   }
    //   .mobile-icon-deposit{
    //     fill: #0C2AAB !important;
    //   }
    // }
  }

  .nav-btn.theme--light.v-list-item--active::before {
    opacity: 0 !important;
  }
}
.profile-nav-active {
  background-color: #3a3a3a !important;
  color: #fff !important;
  .mobile-icon {
    fill: #fff !important;
    path {
      fill: #fff !important;
    }
  }
}

@media (max-width: 1590px) {
  .grey-card {
    .v-btn.v-size--default {
      font-size: 0.7rem !important;
    }
  }
}

@media (max-width: 1271px) {
  .share-div {
    .referralCode-div {
      //flex-basis: 100% !important;
    }
    .share-btn-div {
      //flex-basis: 100% !important;

      .share-btn {
        width: 100% !important;
        flex-basis: 100% !important;
      }
    }
  }
}
</style>
